import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Progress } from 'reactstrap'
import withApolloClient from '../../withApolloClient'

const ReviewIncidentDuplicateStatusMutation = gql`
mutation ReviewIncidentDuplicateStatus($input: ReviewIncidentDuplicateStatusMutationInput!) {
    reviewIncidentDuplicateStatus(input: $input) {
        ok
        errors { messages }
    }
}`

class ChangeIncidentReviewStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            markAsDuplicate: props.currentStatus === "Duplicate" ? true : props.currentStatus === "Not Duplicate" ? false : null,
            loading: false,
            error: null,
        }
    }

    handleSubmit = () => {
        if (this.state.markAsDuplicate === null) return

        this.setState({ loading: true, error: null })
        this.props.apolloClient.mutate({
            mutation: ReviewIncidentDuplicateStatusMutation,
            variables: {
                input: {
                    parentIncidentId: this.props.parentIncidentId,
                    incidentId: this.props.incidentId,
                    markAsDuplicate: this.state.markAsDuplicate,
                },
            },
        }).then((response) => {
            const result = response?.data?.reviewIncidentDuplicateStatus
            if (!result?.ok) {
                const message = result?.errors?.[0]?.messages?.toString() || "Unable to update duplicate status."
                this.setState({ loading: false, error: message })
                return
            }

            this.props.refetchQuery?.()
            this.props.handleClose()
        }).catch((error) => {
            this.setState({ loading: false, error: error.message || "Unable to update duplicate status." })
        })
    }

    render() {
        return (
            <Modal isOpen={this.props.open}>
                <ModalHeader>Change Review Status</ModalHeader>
                <ModalBody>
                    {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                    <p>Select how this incident should be classified in relation to the current incident.</p>
                    <FormGroup check className="mb-2">
                        <Label check>
                            <Input
                                type="radio"
                                name="incidentReviewStatus"
                                checked={this.state.markAsDuplicate === true}
                                onChange={() => this.setState({ markAsDuplicate: true, error: null })}
                            />
                            Mark as duplicate
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input
                                type="radio"
                                name="incidentReviewStatus"
                                checked={this.state.markAsDuplicate === false}
                                onChange={() => this.setState({ markAsDuplicate: false, error: null })}
                            />
                            Mark as not duplicate
                        </Label>
                    </FormGroup>
                    {this.state.loading && <Progress animated color="info" value="100" className="mt-3" />}
                </ModalBody>
                <ModalFooter>
                    <Button className="secondary-btn" onClick={this.props.handleClose} disabled={this.state.loading}>Close</Button>
                    <Button color="primary" className="primary-action-btn" onClick={this.handleSubmit} disabled={this.state.loading || this.state.markAsDuplicate === null}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withApolloClient(ChangeIncidentReviewStatus)
